import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import theme from './theme';
import Layout from './components/Layout';
import ScrollToTop from './components/ScrollToTop';
import HomePage from './pages/HomePage';
import CustomSoftwarePage from './pages/services/CustomSoftwarePage';
import ManagedITPage from './pages/services/ManagedITPage';
import LogisticsPage from './pages/services/LogisticsPage';
import AboutPage from './pages/AboutPage';
import ContactPage from './pages/ContactPage';
import CaseStudiesPage from './pages/resources/CaseStudiesPage';
import BlogPage from './pages/resources/BlogPage';
import CapabilityStatementPage from './pages/CapabilityStatementPage';

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
        <ScrollToTop />
        <Layout>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/services/custom-software" element={<CustomSoftwarePage />} />
            <Route path="/services/managed-it" element={<ManagedITPage />} />
            <Route path="/services/logistics" element={<LogisticsPage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/knowledge/case-studies" element={<CaseStudiesPage />} />
            <Route path="/knowledge/blog" element={<BlogPage />} />
            <Route path="/capability-statement" element={<CapabilityStatementPage />} />
            <Route path="/contact" element={<ContactPage />} />
          </Routes>
        </Layout>
      </Router>
    </ThemeProvider>
  );
}

export default App;
